import { useCallback, useEffect, useState } from 'react';
import { useMap } from 'react-naver-maps';
import { mantangApi as api } from '@/shared/api';
import { MIN_ZOOM_LEVEL } from '@/shared/consts';
import { useDebounce } from '@/shared/lib';
import type { StationsInScreen } from './station.types';

const useStationsInScreenBound = () => {
	const map = useMap();
	const [stationsInScreen, setStationsInScreen] = useState<StationsInScreen>(
		[],
	);

	const fetchStationsInBounds = useCallback(async () => {
		if (map.getZoom() < MIN_ZOOM_LEVEL) return;
		const bounds = map.getBounds();
		const response = await api.getGasStationWithinBoundingBox(
			bounds.getMin().y,
			bounds.getMax().y,
			bounds.getMin().x,
			bounds.getMax().x,
		);
		setStationsInScreen(response.data ?? []);
	}, [map]);

	const debouncedFetchStations = useDebounce(fetchStationsInBounds, 300);

	useEffect(() => {
		const listener = map.addListener('bounds_changed', debouncedFetchStations);
		return () => {
			if (map) map.removeListener(listener);
		};
	}, [map, debouncedFetchStations]);

	return stationsInScreen;
};

export default useStationsInScreenBound;
